<template>
  <div class="overflow-x justify-content-center mt-5">
      <div class=" p-list-representation-table-main">
        <table class="table table-bordered p-table">
            <thead>
              <tr>
                <th>شماره</th>
                <th>نام و نام خانوادگی نماینده</th>
                <th >تاریخ پرداخت</th>
                <th >استان/شهر</th>
                <th >مبلغ تراکنش</th>
                <th >موبایل نماینده</th>
                <th >شماره پیگیری</th>
                <th ></th>

              </tr>
            </thead>
            <tbody>
              <tr v-for="data in tableData" :key="data.id">
                <th scope="row">{{data.id}}</th>
                <th scope="row">{{data.agent.name}}</th>
                <td>{{data.dateConvertedJali}}</td>
                <td>{{data.findProvinceOfAllProvinces.name}}/{{data.findCityOfAllCitys.name}}</td>
                <td>{{data.amountAddCama}}</td>
                <td>{{data.agent.mobile}}</td>
                <td>{{data.transaction_id}}</td>
                <td>
                  <div class="d-flex justify-content-end">
                    <button type="button" class="btn btn-primary btn-blue btn-sm ml-2">مشاهده</button>
                  </div>
                </td>

              </tr>
            </tbody>
          </table>
          <div class="d-flex justify-content-center p-table">
            <pagination v-model="valuePage" :per-page="10" :records="500" @paginate="changePage"/>
          </div>
      </div>

  </div>
</template>

<script>


export default {
    name: 'tableContent',
    props: {
      tableData             : { type: [Array, Object], default: [] },
      page                  : { type: Number, default: 0 },
      resetPagePaganation   : { type: Number, default: 0 },
    },

    data() {
      return {
        valuePage : 1,
      }
    },

    computed: {

    },

    mounted () {
      this.valuePage = this.page;
    },

    watch: {
      page(data){
        this.valuePage = this.page;
      },

      // resetPagePaganation(){
      //   this.valuePage = this.page;
      // },

    },

    methods: {
      changePage(data){
        this.$emit("paganationChangePage",data);
      },

      editRepresentation(){
        this.$emit('editRepresentation');
      }


    },

}
</script>
